import { TenantBaseModel } from '@/features/tenant-manager/_models/tenant';
import { OrganizationBaseModel } from '@/features/tenant-manager/organization/_models/organization';
import { RoleBaseModel } from '@/features/tenant-manager/role/_models/role';
import { isPS, replaceLocationHost } from '@/utils';
import { z } from 'zod';

const MyProfileBaseModel = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
  isActive: z.boolean(),
  iconDataUrl: z.string().nullable(),
  organizationIds: z.string().uuid().array(),
  createdAt: z.string(),
  updatedAt: z.string(),
  modifiedAt: z.string().nullable().optional(),
  secondLastLoginTime: z.string().nullable(),
});

export const MyProfileModel = MyProfileBaseModel.extend({
  role: RoleBaseModel,
  organizations: OrganizationBaseModel.pick({ id: true, name: true }).array(),
  tenant: TenantBaseModel.pick({
    code: true,
    name: true,
    logoUrl: true,
    iconUrl: true,
    faviconUrl: true,
  }).transform((data) => {
    return {
      ...data,
      // 見える化サイトの場合、proxyが存在しないため、URLのホスト名を置き換えない
      logoUrl: replaceLocationHost(data.logoUrl, !isPS()),
      iconUrl: replaceLocationHost(data.iconUrl, !isPS()),
      faviconUrl: replaceLocationHost(data.faviconUrl, !isPS()),
    };
  }),
});
